import {
    HorizAlignment,
    ISearch,
    ISearchProfile,
    ISearchProvider,
    ISearchProviderField,
    ISearchRequestSubset,
    SearchProviderFieldType
} from "../PA.UIM.Core/PA.UIM.Core.IF.Search"
import {SearchUtils} from "../PA.UIM.Core/SearchUtils";
import {PASearch} from "../PA.Core/PASearch";
import {PAEnvironment} from "../PA.Core/PAEnvironment";

const vUI_Product_Attribute_Map_Search_Fields: {[id: string]: ISearchProviderField} = {
    WB_PRDATTRMAP_ID:             {type: SearchProviderFieldType.number,   renderOptions: { columnName: 'WB Product Attr Map Id',    columnResourceName: 'colId',               alignment: HorizAlignment.Left},  domainOptions: {}},
    ATTRIB_MAP_ID:                {type: SearchProviderFieldType.string,   renderOptions: { columnName: 'Attrib Map Id',             columnResourceName: 'colId',               alignment: HorizAlignment.Left},  domainOptions: {maxLength: 50}},
    ATTRIB_MAP_NAME:              {type: SearchProviderFieldType.string,   renderOptions: { columnName: 'Attrib Map Name',           columnResourceName: 'colName',             alignment: HorizAlignment.Left},  domainOptions: {maxLength: 256}},
    ATTRIB_MAP_TYPE:              {type: SearchProviderFieldType.string,   renderOptions: { columnName: 'Attrib Map Type',           columnResourceName: 'colType',             alignment: HorizAlignment.Left},  domainOptions: {maxLength: 50}},
    TREEPATH:                     {type: SearchProviderFieldType.string,   renderOptions: { columnName: 'TreePath',                  columnResourceName: 'colTreePath',         alignment: HorizAlignment.Left},  domainOptions: {maxLength: 256}},
    SOURCE_ID:                    {type: SearchProviderFieldType.string,   renderOptions: { columnName: 'Source Id',                 columnResourceName: 'colSrcId',            alignment: HorizAlignment.Left},  domainOptions: {maxLength: 50}},
    ATTRIBUTE_ID:                 {type: SearchProviderFieldType.string,   renderOptions: { columnName: 'Attrib Id',                 columnResourceName: 'colAttrId',           alignment: HorizAlignment.Left},  domainOptions: {maxLength: 50}},
    TARGET_FIELDNAME:             {type: SearchProviderFieldType.string,   renderOptions: { columnName: 'Target FieldName ',         columnResourceName: 'colTrgtFldName',      alignment: HorizAlignment.Left},  domainOptions: {maxLength: 50}},
    CREATED_DTTS:                 {type: SearchProviderFieldType.sapdate,  renderOptions: { columnName: 'Created Date',              columnResourceName: 'colCreatedDate',      alignment: HorizAlignment.Left},  domainOptions: {}},
    MODIFIED_DTTS:                {type: SearchProviderFieldType.sapdate,  renderOptions: { columnName: 'Created Date',              columnResourceName: 'colModifiedDate',     alignment: HorizAlignment.Left},  domainOptions: {}},
    DELETED_IND:                  {type: SearchProviderFieldType.string,   renderOptions: { columnName: 'Deleted Ind',               columnResourceName: 'colDeletedInd',       alignment: HorizAlignment.Left},  domainOptions: {}},
    DELETED_DT:                   {type: SearchProviderFieldType.sapdate,  renderOptions: { columnName: 'Deleted Date',              columnResourceName: 'colDeleted_Date',     alignment: HorizAlignment.Left},  domainOptions: {}}
};

const ProductAttributeMapSearchProviderBasic: ISearchProvider = {

    keyFields: {id: 'WB_PRDATTRMAP_ID',
        id_ui: 'ATTRIB_MAP_ID',
        name: 'ATTRIB_MAP_NAME'
    },

    searchProviderFields: vUI_Product_Attribute_Map_Search_Fields,

    search(searchRequestSubset: ISearchRequestSubset): Promise<any[]> {
        return new Promise<any[]>((resolve, error)=>{
            let findRequest = SearchUtils.makeSearchRequest(searchRequestSubset,
                'vUI_Product_Attribute_Map_Search',
                this.searchProviderFields,
                []);

            PASearch.findByRequest(findRequest)
                .then((res:any)=>{
                    resolve(res)
                })
                .catch((err)=>{
                    error(err)
                })
        })
    }
};

const ProductAttributeMapSearchProfileByName: ISearchProfile = {
    profileId: "default",
    profileName: "Search by Id, Name",
    renderOptions: {ui5ResourceId: "ProductAttributeMapSearchProfileByName"},

    profileFilter: [
        {profileFilterName: 'Id', searchProviderFieldId: 'ATTRIB_MAP_ID', renderOptions: {}},
        {profileFilterName: 'Name', searchProviderFieldId: 'ATTRIB_MAP_NAME', renderOptions: {}}
    ], //ISearchFields
    profileDisplayFields: [
        'ATTRIB_MAP_ID', 'ATTRIB_MAP_NAME', 'SOURCE_ID', 'ATTRIBUTE_ID',
        'CREATED_DTTS', 'MODIFIED_DTTS'
    ], //string[];   // Search Provider Field Name (Use to Generate Grid Columns)

    profileSearchProvider: ProductAttributeMapSearchProviderBasic,

    // Do sorting last.. not necessary for phase 1
    profileSortIdDefault: "",    //string;
    profileSorts: [] //ISearchSort[];
};

const ProductAttributeMapSearch: ISearch = {
    searchName: "Find Product Attribute Map",
    renderOptions: {ui5ResourceId: "ProductAttributeMapSearch"},
    searchProfileIdDefault: "default",
    searchProfiles: [ProductAttributeMapSearchProfileByName]
};
PAEnvironment.registerBusinessObjectSearch("ProductAttributeMapBO", "ProductAttributeMap", ProductAttributeMapSearch, "Product Attribute Map Search")

export {ProductAttributeMapSearch}